import { TextField, styled } from '../../../../base';

export const InputPlaceholderStyled = styled(TextField)(({ theme }) => ({
    marginBottom: theme.spacing(1.5),
}));
